import React from "react";
import ReporteSeguimientosClientes  from "../components/ReporteSeguimientosClientes";

const InformeSeguimientosClientes = () => {
  return (
    <>
      <ReporteSeguimientosClientes  />
    </>
  );
};

export default InformeSeguimientosClientes;